import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 * @param organisationId string
 * @param reportId string
 * @param parameterId string
 *
 * @return {Promise<any>|Promise}
 */
export default (function (organisationId, reportId, parameterId) {
    var url = applyPathVariables(EndPoints.REPORTS_FILTER_VALUES, {
        organisationId: organisationId,
        reportId: reportId,
        parameterId: parameterId,
    });
    var headers = { 'Content-Type': 'application/json' };
    var request = new Request({ method: Methods.GET, url: url, withCredentials: true, data: null, headers: headers });
    return request.execute();
});
